import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import './applicationTableManageDocuments.scss' 
import { Link } from 'react-router-dom';
import { ref, getBlob, getDownloadURL } from 'firebase/storage'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { doc, getDoc, updateDoc, onSnapshot, collection, query, orderBy, addDoc, serverTimestamp } from "firebase/firestore"
import { auth, db} from '../../firebase'


const ApplicationTableManageDocument = ({  applicationId}) => {

    

    const [availableInternationalPassport, setAvailableInternationalPassport] = React.useState("");
    const [availablePassportPhotograph, setAvailablePassportPhotograph] = React.useState("");
    const [availableBirthCertificate, setAvailableBirthCertificate] = React.useState("");
    const [availableMarriageCertificate, setAvailableMarriageCertificate] = React.useState("");
    const [availableStatementOfAccount, setAvailableStatementOfAccount] = React.useState("");
    const [availableCompanyIntroduction, setAvailableCompanyIntroduction] = React.useState("");
    const [availableSelfIntroduction, setAvailableSelfIntroduction] = React.useState("");
    const [availableLeaveApprovalLetter, setAvailableLeaveApprovalLetter] = React.useState("");
    const [availableEmploymentLetter, setAvailableEmploymentLetter] = React.useState("");

    const [unavailableInternationalPassport, setUnavailableInternationalPassport] = React.useState("");
    const [unavailablePassportPhotograph, setUnavailablePassportPhotograph] = React.useState("");
    const [unavailableBirthCertificate, setUnavailableBirthCertificate] = React.useState("");
    const [unavailableMarriageCertificate, setUnavailableMarriageCertificate] = React.useState("");
    const [unavailableStatementOfAccount, setUnavailableStatementOfAccount] = React.useState("");
    const [unavailableCompanyIntroduction, setUnavailableCompanyIntroduction] = React.useState("");
    const [unavailableSelfIntroduction, setUnavailableSelfIntroduction] = React.useState("");
    const [unavailableLeaveApprovalLetter, setUnavailableLeaveApprovalLetter] = React.useState("");
    const [unavailableEmploymentLetter, setUnavailableEmploymentLetter] = React.useState("");

    const [applicationData, setapplicationData] = useState([])


    // Available Documents

    const handleChangeAvailableInternationalPassport = (event) => {

        setAvailableInternationalPassport(event.target.value);
        
        const internationalPassportRef = doc(db, "visa", applicationId);
        updateDoc(internationalPassportRef, {
            availableInternationalPassport: availableInternationalPassport
          });

          
    };

    const handleChangeAvailablePassportPhotograph = (event) => {

        setAvailablePassportPhotograph(event.target.value);
        
        const passportPhotographRef = doc(db, "visa", applicationId);
        updateDoc(passportPhotographRef, {
            availablePassportPhotograph: availablePassportPhotograph
        });

          
    };

    const handleChangeAvailableBirthCertificate = (event) => {

        setAvailableBirthCertificate(event.target.value);

        const birthCertificateRef = doc(db, "visa", applicationId);
        updateDoc(birthCertificateRef, {
            availableBirthCertificate: availableBirthCertificate
        });
        

    };

      const handleChangeAvailableMarriageCertificate = (event) => {

        setAvailableMarriageCertificate(event.target.value);

        const marriageCertificateRef = doc(db, "visa", applicationId);
        updateDoc(marriageCertificateRef, {
            availableMarriageCertificate: availableMarriageCertificate
        });
        
      };

      const handleChangeAvailableStatementOfAccount = (event) => {

        setAvailableStatementOfAccount(event.target.value);

        const statementOfAccountRef = doc(db, "visa", applicationId);
        updateDoc(statementOfAccountRef, {
            availableStatementOfAccount: availableStatementOfAccount
        });
        
      };

      const handleChangeAvailableCompanyIntroduction = (event) => {

        setAvailableCompanyIntroduction(event.target.value);

        const companyIntroductionRef = doc(db, "visa", applicationId);
        updateDoc(companyIntroductionRef, {
            availableCompanyIntroduction: availableCompanyIntroduction
        });
        
      };

      const handleChangeAvailableSelfIntroduction = (event) => {
        setAvailableSelfIntroduction(event.target.value);

        const selfIntroductionRef = doc(db, "visa", applicationId);
        updateDoc(selfIntroductionRef, {
            availableSelfIntroduction: availableSelfIntroduction
        });
       
      };

      const handleChangeAvailableLeaveApprovalLetter = (event) => {

        setAvailableLeaveApprovalLetter(event.target.value);

        const leaveApprovalLetterRef = doc(db, "visa", applicationId);
        updateDoc(leaveApprovalLetterRef, {
            availableLeaveApprovalLetter: availableLeaveApprovalLetter
        });
        
      };

      const handleChangeAvailableEmploymentLetter = (event) => {
        setAvailableEmploymentLetter(event.target.value);

        const employmentLetterRef = doc(db, "visa", applicationId);
        updateDoc(employmentLetterRef, {
            availableEmploymentLetter: availableEmploymentLetter
        });
        
      };


      // unavialable Documents

      
    const handleChangeUnavailableInternationalPassport = (event) => {

        setUnavailableInternationalPassport(event.target.value);
        
        const internationalPassportRef = doc(db, "visa", applicationId);
        updateDoc(internationalPassportRef, {
            unavailableInternationalPassport: unavailableInternationalPassport
          });

          
    };

    const handleChangeUnavailablePassportPhotograph = (event) => {

        setUnavailablePassportPhotograph(event.target.value);
        
        const passportPhotographRef = doc(db, "visa", applicationId);
        updateDoc(passportPhotographRef, {
            unavailablePassportPhotograph: unavailablePassportPhotograph
        });

          
      };

      const handleChangeUnavailableBirthCertificate = (event) => {

        setUnavailableBirthCertificate(event.target.value);

        const birthCertificateRef = doc(db, "visa", applicationId);
        updateDoc(birthCertificateRef, {
            unavailableBirthCertificate: unavailableBirthCertificate
        });
        

      };

      const handleChangeUnavailableMarriageCertificate = (event) => {

        setUnavailableMarriageCertificate(event.target.value);

        const marriageCertificateRef = doc(db, "visa", applicationId);
        updateDoc(marriageCertificateRef, {
            unavailableMarriageCertificate: unavailableMarriageCertificate
        });
        
      };

      const handleChangeUnavailableStatementOfAccount = (event) => {

        setUnavailableStatementOfAccount(event.target.value);

        const statementOfAccountRef = doc(db, "visa", applicationId);
        updateDoc(statementOfAccountRef, {
            unavailableStatementOfAccount: unavailableStatementOfAccount
        });
        
      };

      const handleChangeUnavailableCompanyIntroduction = (event) => {

        setUnavailableCompanyIntroduction(event.target.value);

        const companyIntroductionRef = doc(db, "visa", applicationId);
        updateDoc(companyIntroductionRef, {
            unavailableCompanyIntroduction: unavailableCompanyIntroduction
        });
        
      };

      const handleChangeUnavailableSelfIntroduction = (event) => {
        setUnavailableSelfIntroduction(event.target.value);

        const selfIntroductionRef = doc(db, "visa", applicationId);
        updateDoc(selfIntroductionRef, {
            unavailableSelfIntroduction: unavailableSelfIntroduction
        });
       
      };

      const handleChangeUnavailableLeaveApprovalLetter = (event) => {

        setUnavailableLeaveApprovalLetter(event.target.value);

        const leaveApprovalLetterRef = doc(db, "visa", applicationId);
        updateDoc(leaveApprovalLetterRef, {
            unavailableLeaveApprovalLetter: unavailableLeaveApprovalLetter
        });
        
      };

      const handleChangeUnavailableEmploymentLetter = (event) => {
        setUnavailableEmploymentLetter(event.target.value);

        const employmentLetterRef = doc(db, "visa", applicationId);
        updateDoc(employmentLetterRef, {
            unavailableEmploymentLetter: unavailableEmploymentLetter
        });
        
      };    
      
      const getVisaInfo = async() => {
      const docRef = doc(db, "visa", applicationId);

            const docSnap = await getDoc(docRef);

                
            if (docSnap.exists()) {

            setapplicationData(docSnap.data() )

            } else {
            
            console.log("No such document!");
            }


        }



        // console.log(applicationData)

        // console.log('image: ',validDocument)

        

        useEffect(()=>{

        getVisaInfo()

        }, [])
  


        const downloadImage = (url) =>{

        
          fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
              const url = window.URL.createObjectURL(new Blob([blob]));
              const link = document.createElement("a");
              link.href = url;
              link.download = "downloaded-file";
              document.body.appendChild(link);
      
              link.click();
      
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              console.error("Error fetching the file:", error);
            });
       

        }


  return (
            
    <div className=''>

        
    <div >
        <div >

        <h4 style={{fontSize:18}}>Available Documents</h4>

            {
                applicationData.internationalPassport === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                    <div style={{display:'flex', flexDirection:'row', width:300}}>
                        <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>International Passport:</span>
                        {/* <span className='itemValue'>{applicationData.internationalPassport}</span> */}
                    </div>
                    

                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10, alignItems:'center'}}>

                    {/* <a href={applicationData.internationalPassportImage} download>View</a> */}

                    <div>
                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableInternationalPassport}
                            onChange={ handleChangeAvailableInternationalPassport }
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>



                        {/* <button
                                // onClick={() => openDelete(item)}
                                onClick={() => downloadImage(applicationData.internationalPassportImage)}
                                className="downloadbutton"
                                // download
                            >
                                Download
                        </button> */}

                    </div>
                  
                   
                </div>
                :

                ""
            }  

         

                 {
                applicationData.passportPhotograph === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                    <div style={{display:'flex', flexDirection:'row', width:300}}>
                        <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Passport Photograph:</span>
                        {/* <span className='itemValue'>{applicationData.passportPhotograph}</span> */}
                    </div>
                    

                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.passportPhotographImage} download>View</a> */}
                    <div>
                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availablePassportPhotograph}
                            onChange={handleChangeAvailablePassportPhotograph}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>

                    </div>
                  
                   
                </div>
                :

                ""
            }     

       

            {
                applicationData.birthCertificate  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Birth Certificate:</span>
                    {/* <span className='itemValue'>{applicationData.birthCertificate }</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.birthCertificateImage } download>View</a> */}

                    <div>
                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableBirthCertificate}
                            onChange={handleChangeAvailableBirthCertificate}
                        >
                           <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>

                    </div>
                  
                   
                </div>
                :

                ""
            }  

             

            {
                applicationData.marriageCertificate  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Marriage Certificate:</span>
                    {/* <span className='itemValue'>{applicationData.marriageCertificate}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.marriageCertificateImage} download>View</a> */}

                    <div>
                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableMarriageCertificate}
                            onChange={handleChangeAvailableMarriageCertificate}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>

                    </div>
                  
                   
                </div>
                :

                ""
            }  


           

            {
                applicationData.statementOfAccount  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Statement of Account:</span>
                    {/* <span className='itemValue'>{applicationData.statementOfAccount}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.statementOfAccountImage} download>View</a> */}

                    <div>
                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableStatementOfAccount}
                            onChange={handleChangeAvailableStatementOfAccount}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>

                    </div>
                  
                   
                </div>
                :

                ""
            }  


            


            {
                applicationData.companyIntroduction  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Company Introduction Letter:</span>
                    {/* <span className='itemValue'>{applicationData.companyIntroduction}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.companyIntroductionImage} download>View</a> */}

                    <div>
                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableCompanyIntroduction}
                            onChange={handleChangeAvailableCompanyIntroduction}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>

                    </div>
                  
                   
                </div>
                :

                ""
            }  

           


            {
                applicationData.selfIntroduction  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Self Introduction Letter:</span>
                    {/* <span className='itemValue'>{applicationData.selfIntroduction}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.selfIntroductionImage} download>View</a> */}

                    <div>
                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableSelfIntroduction}
                            onChange={handleChangeAvailableSelfIntroduction}
                        >
                           <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>

                    </div>
                  
                   
                </div>
                :

                ""
            }  


              {
                applicationData.leaveApprovalLetter  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Leave Approval Letter:</span>
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>


                    <div>
                         <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableLeaveApprovalLetter}
                            onChange={handleChangeAvailableLeaveApprovalLetter}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>
                    </div>

                    </div>
                  
                   
                </div>
                :

                ""
            }  



        
            {
                applicationData.employmentLetter  === "available"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Employment Letter:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={availableEmploymentLetter}
                            onChange={handleChangeAvailableEmploymentLetter}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  
            
          
        
        </div>

    </div>  

    <div>     

        <div >

        <h4>Unavailable Documents</h4>


            {
                applicationData.internationalPassport === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>International Passport:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableInternationalPassport}
                            onChange={handleChangeUnavailableInternationalPassport}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  

             {
                applicationData.passportPhotograph === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Passport Photograph:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailablePassportPhotograph}
                            onChange={handleChangeUnavailablePassportPhotograph}
                        >
                           <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }      

            {
                applicationData.birthCertificate === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Birth Certificate:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableBirthCertificate}
                            onChange={handleChangeUnavailableBirthCertificate}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  

             {
                applicationData.marriageCertificate === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Marriage Certificate:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableMarriageCertificate}
                            onChange={handleChangeUnavailableMarriageCertificate}
                        >
                         <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  
              


              {
                applicationData.statementOfAccount === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Statement of Account:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableStatementOfAccount}
                            onChange={handleChangeUnavailableStatementOfAccount}
                        >
                           <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  

             {
                applicationData.companyIntroduction === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Company Introduction:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableCompanyIntroduction}
                            onChange={handleChangeUnavailableCompanyIntroduction}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }      

            {
                applicationData.selfIntroduction === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Self Introduction:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableSelfIntroduction}
                            onChange={handleChangeUnavailableSelfIntroduction}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  

             {
                applicationData.leaveApprovalLetter === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Leave Approval Letter:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableLeaveApprovalLetter}
                            onChange={handleChangeUnavailableLeaveApprovalLetter}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  
                
                {
                applicationData.employmentLetter === "unavailable"
                ?
                <div  style={{display:'flex', flexDirection:'row', marginBottom:10, alignItems:'center', gap:50}}>
                <div style={{display:'flex', flexDirection:'row', width:300}}>
                    <span style={{fontWeight:'bold', marginRight:5, color:"#00000088"}}>Employment Letter:</span>
                    {/* <span className='itemValue'>{applicationData.employmentLetter}</span> */}
                </div>
                    <div  style={{display:'flex', flexDirection:'row', marginLeft:10, gap:10}}>

                    {/* <a href={applicationData.employmentLetterImage} download>View</a> */}

                         <FormControl>
                        {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={unavailableEmploymentLetter}
                            onChange={handleChangeUnavailableEmploymentLetter}
                        >
                            <FormControlLabel value="pending" control={<Radio />} label="Pending" />
                            <FormControlLabel value="rejected" control={<Radio />} label="Approved" />
                            <FormControlLabel value="approved" control={<Radio />} label="Rejected" />
                        </RadioGroup>
                        </FormControl>

                    </div>
                  
                   
                </div>
                :

                ""
            }  
            
          
        
        </div>

    </div>
    </div>
   
  );
}


export default ApplicationTableManageDocument